















































































































































































































































































































































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import ProfileTab from '@/components/member/memberCommon/accountDetailModal/ProfileTab.vue';
import JoinProjectTab from '@/components/member/memberCommon/accountDetailModal/JoinProjectTab.vue';
import { Socials, WithNumber } from '@/@types/LibraryComponent.js';
import CommonButton from '@/components/common/CommonButton.vue';
import AccountIcon from '@/components/common/AccountIcon.vue';

@Component({
  components: {
    ProfileTab,
    JoinProjectTab,
    AccountIcon
  },
})
export default class AccountDetailModalBase extends Vue {
  @Prop(Boolean)
  public isOpenAccountDetailDrawer!: boolean;
  private isOpenAccountDetailDrawerEmit = this.isOpenAccountDetailDrawer;
  private rating: number = 4;
  private techniqueRating: number = 4;
  private communicationRating: number = 4;
  private understandingRating: number = 4;
  private saiyoFlag: boolean = false;
  private message = false;
  private webFlag: boolean = false;
  private tab = null;
  private rollMouseOver: boolean = false;
  private scrollY: number = 0;
  private scrollReferencePoint: number = 100;
  private isScrollLower: boolean = false;
  private isFavorite: boolean = false;
  private socials: Array<Socials> = [
    {
      icon: 'mdi-hand-heart',
      color: 'indigo',
      notDisabled: true,
      text: '参画オファー',
    },
    {
      icon: 'mdi-laptop-chromebook',
      color: 'cyan darken-1',
      notDisabled: true,
      text: 'web面談オファーして検討する',
    },
    {
      icon: 'mdi-heart',
      color: 'red lighten-3',
      notDisabled: true,
      text: '気になる',
    },
  ];
  private widthNumber: WithNumber = {
    dialog: [1200, 800],
    accountDetail: [600, 800],
    chatMessage: [600, 0],
  };

  private starColor(): 'yellow darken-1' | 'rgba(255, 255, 255, 0.8)' {
    if (this.isFavorite) {
      return 'yellow darken-1';
    }
    return 'rgba(255, 255, 255, 0.8)';
  }

  private clickedActionButton(notDisabled: boolean, icon: string): void {
    const selectContent:
      | {
          icon: string;
          color: string;
          notDisabled: boolean;
          text: string;
        }
      | undefined = this.socials.find((x) => x.icon === icon);
    if (selectContent) {
      if (notDisabled) {
        selectContent.notDisabled = false;
      } else {
        selectContent.notDisabled = true;
      }
    }
  }

  private returnWidth(pixel1: number, pixel2: number): string {
    if (this.message) {
      if (pixel1 === 600) {
        return '600px';
      } else {
        return '1200px';
      }
    } else {
      if (pixel2 === 800) {
        return '800px';
      } else {
        return '0px';
      }
    }
  }

  private color(color: string, notDisabled: boolean): 'white' | string {
    if (notDisabled) {
      return 'white';
    } else {
      return color;
    }
  }

  private mounted(): void {
    const targetElement: HTMLElement | null = document.getElementById('scrollBarTarget');
    if (targetElement) {
      targetElement.addEventListener('scroll', this.handleScroll);
    }
  }
  private handleScroll(): void {
    const targetElement: HTMLElement | null = document.getElementById('scrollBodyTarget');
    if (targetElement) {
      const clientRect: DOMRect = targetElement.getBoundingClientRect();
      this.scrollY = clientRect.top;
    }
    if (this.scrollY < this.scrollReferencePoint) {
      this.isScrollLower = true;
    } else {
      this.isScrollLower = false;
    }
  }

  private scrollIconSize(): number {
    if (this.isScrollLower) {
      return 50;
    } else {
      return 100;
    }
  }
  @Emit('onCloseAccountDetailDrawer')
  private closeAccountDetailDrawer(): void {
this.isOpenAccountDetailDrawerEmit = false;
  }
}
